import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface AuthState {
  id?: number;
  token?: string;
  name?: string;
  role?: string;
  nursery?: { id: number; name: string } | null;
  restored: boolean;
}

const initialState: AuthState = { restored: false };

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    restoreAuth: (
      state,
      action: PayloadAction<Omit<AuthState, "restored">>,
    ) => {
      state.id = action.payload.id;
      state.token = action.payload.token;
      state.name = action.payload.name;
      state.role = action.payload.role;
      state.nursery = action.payload.nursery;
      state.restored = true;
    },
    login: (state, action: PayloadAction<Omit<AuthState, "restored">>) => {
      state.id = action.payload.id;
      state.token = action.payload.token;
      state.name = action.payload.name;
      state.role = action.payload.role;
      state.nursery = action.payload.nursery;
      state.restored = true;
    },
    logout: (state) => {
      delete state.id;
      delete state.token;
      delete state.name;
      delete state.role;
      delete state.nursery;
      // restored stays true: "no auth" differs from "haven't checked yet"
    },
  },
});

export const { login, logout, restoreAuth } = authSlice.actions;
export default authSlice.reducer;
